module.exports = __webpack_public_path__ + "media/images/flags/32/Philippines-4aa7a2a6f65413e182887a5f4af2e7ed.png";